import Vue from 'vue';
import { get, head, isNil } from 'lodash';

import { apolloClient } from '@/plugins/vue-apollo';
import { resetRouter, extendRouter } from '@/router';
import { fetchUserProfile } from '@/store/graphql/queries/user';
import AuthService from '@/services/AuthService';
import Routes from '@/router/routes';

export default {
  namespaced: true,
  state: {
    currentUser: null,
    routesAssgineds: 'public',
    currentRoutes: [],
  },
  actions: {
    assignRoutes({ commit }) {
      commit('SET_ASSIGNED_ROUTES');
    },
    setCurrentUser({ commit }, currentUser) {
      commit('SET_CURRENT_USER', get(currentUser, 'profile'));
      commit('SET_ASSIGNED_ROUTES');
    },
    login() {
      new AuthService().login();
    },
    logout() {
      new AuthService().logout();
    },
    async update({ dispatch }) {
      const currentUser = await new AuthService().update();
      dispatch('setCurrentUser', currentUser);
    },
    async getUserProfile({ commit }) {
      try {
        const userProfileQuery = {
          mutation: fetchUserProfile,
        };
        const result = await apolloClient.mutate(userProfileQuery);
        if (result && result.data && result.data.user_profile) {
          commit('SET_CURRENT_USER_PROFILE', head(result.data.user_profile));
        }
        return result;
      } catch (error) {
        throw new Error(error);
      }
    },
  },
  mutations: {
    SET_CURRENT_USER_PROFILE(state, userProfile) {
      const profile = {
        userId: userProfile.id,
        firstName: userProfile.first_name,
        lastName: userProfile.last_name,
        fullName: `${userProfile.first_name} ${userProfile.last_name}`,
        activated: !isNil(userProfile.activated_at),
        locked: !isNil(userProfile.locked_at),
        organization: head(userProfile.organizations),
      };

      Vue.set(state.currentUser, 'profile', profile);
    },
    SET_CURRENT_USER(state, currentUser) {
      Vue.set(state, 'currentUser', currentUser);
    },
    SET_ASSIGNED_ROUTES(state) {
      const currentUserRole = get(state.currentUser, 'x-hasura-default-role');
      if (currentUserRole && state.routesAssgineds !== currentUserRole) {
        const newRoutes = Routes[currentUserRole];
        if (newRoutes && newRoutes.length) {
          extendRouter(newRoutes);
          Vue.set(state, 'currentRoutes', newRoutes);
          Vue.set(state, 'routesAssgineds', currentUserRole);
        } else {
          resetRouter();
        }
      }
    },
  },
  getters: {
    currentUser: state => state.currentUser,
    currentUserRoleInfo: state => get(state.currentUser, 'x-hasura-default-role'),
    currentUserProfileInfo: (state) => {
      const currentUser = state.currentUser;
      if (!currentUser) {
        return null;
      }
      return currentUser.profile;
    },
    isAuthenticated: async () => {
      const data = await new AuthService().getUser();
      return data;
    },
    routesAssginedsInfo: state => state.routesAssgineds,
    currentRoutesInfo: state => state.currentRoutes,
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/core/auth.js